export default "/images/icon-ai-pencil.gif?13b72cf31b25bf268563e26d40c26491";